import { createContext, useContext } from 'react';

export const AdminSidebarContext = createContext({
  sidebarCollapsed: false,
  toggleSidebar: () => {},
});

export const useAdminSidebar = () => useContext(AdminSidebarContext);
